import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Flex, Icon, useMediaQuery } from "@ebscois/react-component-library";

import {
  CopyLinkInput,
  CopyLinkButton,
  CopyLinkWrapper,
  CopiedLinkLabel,
  CopyLinkButtonWrapper,
} from "./_.styled";
import { copyToClipboard } from "../../util/copyToClipboard";

const COPY_TIMEOUT = 5000;

const noop = () => null;

const CopyLink = ({ url, label, btnLabel }) => {
  const inputRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  const maxSmMq = useMediaQuery("max", "sm");

  const handleCopyLink = () => {
    if (inputRef?.current) {
      copyToClipboard(url);
      setIsCopied(true);
    }
  };

  useEffect(() => {
    if (!isCopied) {
      return noop;
    }

    const timer = setTimeout(() => setIsCopied(false), COPY_TIMEOUT);

    return () => {
      clearTimeout(timer);
    };
  }, [isCopied]);

  return (
    <CopyLinkWrapper>
      <Flex container wrap>
        <Flex cell span={maxSmMq ? 12 : 9}>
          <CopyLinkInput
            ref={inputRef}
            name="CopyLinkInput"
            aria-label="URL for copying"
            type="text"
            required
            value={url}
            size="sm"
          />
        </Flex>
        <CopyLinkButtonWrapper
          cell
          span={maxSmMq ? 12 : 3}
          align={{ item: "center" }}
          paddingTop="8px"
        >
          {!isCopied ? (
            <CopyLinkButton
              onClick={handleCopyLink}
              size="sm"
              fontSize="lg"
              variant="primary"
            >
              {btnLabel}
            </CopyLinkButton>
          ) : (
            <>
              <Icon
                icon={{ glyph: "check_circle", color: "green", size: "md" }}
              />
              &nbsp;
              <CopiedLinkLabel color="green" fontWeight="bold" fontSize="sm">
                {label}
              </CopiedLinkLabel>
            </>
          )}
        </CopyLinkButtonWrapper>
      </Flex>
    </CopyLinkWrapper>
  );
};

CopyLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  btnLabel: PropTypes.string.isRequired,
};

CopyLink.displayName = "CopyLink";

export default CopyLink;
